import File from './file/index';

export const FileManagerService = {
  File,
};
